import { useOrg } from './useOrg';

export function useSelectedOrganization() {
  const orgContext = useOrg();
  return orgContext.selectedOrg;
}

/**
 * Retrieve the selected organization from localStorage for non-React contexts.
 * Returns null if no organization is stored or parsing fails.
 */
export function getSelectedOrganization(): ReturnType<
  typeof useSelectedOrganization
> {
  if (typeof window === 'undefined') {
    return null;
  }
  const stored = localStorage.getItem('selectedOrg');
  if (!stored) {
    return null;
  }
  try {
    return JSON.parse(stored) as ReturnType<typeof useSelectedOrganization>;
  } catch {
    console.warn('getSelectedOrganization: invalid JSON in localStorage');
    return null;
  }
}
